// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-backdrop[data-v-c3ac3878]{background:rgba(250,100,100,.4)}.modal-backdrop .modal[data-v-c3ac3878]{width:420px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
